import React  from "react";
import { useParams } from "react-router-dom";
import AssetManagementForm from "./components/AssetManagementForm";

const EditAsset = ()  => {
	const { recordId } = useParams();
	
	return (
		<AssetManagementForm
			recordId={recordId}
			mode="edit"
		/>
	);
};

export default EditAsset;